import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export const DraggableTabNode = ({ className, ...props }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props["data-node-key"],
  });

  const style = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: "move",
    transformOrigin: "center center",
    ...(isDragging && {
      zIndex: 1000,
      boxShadow: `
        5px 5px 0px 0px rgba(0, 0, 0, 0.3), 
        -2px -2px 0px 0px rgba(255, 255, 255, 0.2),
        2px 2px 0px 0px rgba(0, 0, 0, 0.1) 
      `,
      transform: `${CSS.Translate.toString(
        transform
      )} translateZ(10px) rotateX(2deg) rotateY(2deg) scale(1.05)`,
    }),
    ...(!isDragging && {
      boxShadow: "1px 1px 0px 0px rgba(0, 0, 0, 0.1)",
    }),
  };

  return React.cloneElement(
    props.children,
    Object.assign(
      Object.assign({ ref: setNodeRef, style }, attributes),
      listeners
    )
  );
};
